<template>
  <div class="back">
    <div style="text-align: center;margin: 40px 0px 20px 0px" >
      <img style="width:40%;height: 40%;" src="../assets/tablan.png" alt="">
    </div>
    <div style="height: 25px;
      color: #000;
      font-family: PingFang SC;
      font-size: 18px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
      letter-spacing: .36px;
      margin-left: 5%;">大模型语言</div>
    <div class="main">
      <a-row :gutter="48">
        <a-col :sm="10" :xl="7" :xs="10" :lg="7">
          <a href="https://yiyan.baidu.com/" target="_blank">
            <img class="hover-image" src="https://pica.zhimg.com/v2-42b1f26b12f78f6ecfa730ed5695b230_l.jpg?source=d0bb80aa" alt="">
          </a>
        </a-col>
        <a-col :sm="10" :xl="7" :xs="10" :lg="7">
          <a href="https://tongyi.aliyun.com/qianwen" target="_blank">
            <img class="hover-image" src="https://pic1.zhimg.com/v2-07c4168c9bf4e88087a2f83f0ba5fa2f_l.jpg?source=d0bb80aa" alt="">
          </a>
        </a-col>
        <a-col :sm="10" :xl="7" :xs="10" :lg="7">
          <a href="https://xinghuo.xfyun.cn/" target="_blank">
            <img class="hover-image" src="https://pic1.zhimg.com/v2-6c6d53cceacf83c83a12e13aa5a0e203_l.jpg?source=d0bb80aa" alt="">
          </a>
        </a-col>
      </a-row>
    </div>
    <div>
      <div style="height: 25px;
        color: #000;
        font-family: PingFang SC;
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        letter-spacing: .36px;
        margin-left: 5%;
        margin-top:50px;">智能文本处理
      </div>
      <div class="main">
        <a-row :gutter="48">
          <a-col :sm="6" :xl="4" :xs="30" :lg="4">
            <a href="https://ai.wps.cn/" target="_blank">
              <img class="hover-image" src="https://picx.zhimg.com/v2-07688a244ea1f0413bd3f99bda27faab_l.jpg?source=d0bb80aa" alt="">
            </a>
          </a-col>
          <a-col :sm="6" :xl="4" :xs="30" :lg="4">
            <a href="https://xiezuocat.com/?" target="_blank">
              <img class="hover-image" src="https://picx.zhimg.com/v2-22bbdf53c92fa1ec0f72a7a68d80958e_l.jpg?source=d0bb80aa" alt="">
            </a>
          </a-col>
          <a-col :sm="6" :xl="4" :xs="30" :lg="4">
            <a href="https://chat2doc.cn/" target="_blank">
              <img class="hover-image" src="https://picx.zhimg.com/v2-e111bf12ed6dc29835a8d94722320db6_l.jpg?source=d0bb80aa" alt="">
            </a>
          </a-col>
          <a-col :sm="6" :xl="4" :xs="30" :lg="4">
            <a href="https://doc.smartread.cc/" target="_blank">
              <img class="hover-image" src="https://pica.zhimg.com/v2-e1483515324700137535cd2a76626b17_l.jpg?source=d0bb80aa" alt="">
            </a>
          </a-col>
          <a-col :sm="6" :xl="4" :xs="30" :lg="4">
            <a href="https://www.notion.so/" target="_blank">
              <img class="hover-image" src="https://pica.zhimg.com/v2-80f25b60e2712f1fa9dfaa91f20e9bee_l.jpg?source=d0bb80aa" alt="">
            </a>
          </a-col>
          <a-col :sm="6" :xl="4" :xs="30" :lg="4">
            <a href="https://www.aippt.cn/" target="_blank">
              <img class="hover-image" src="https://picx.zhimg.com/v2-dfb01e394a5b38d52e604f585be81983_l.jpg?source=d0bb80aa" alt="">
            </a>
          </a-col>
          <a-col :sm="6" :xl="4" :xs="30" :lg="4">
            <a href="https://ppt.sankki.com/#/intro" target="_blank">
              <img class="hover-image" src="https://pic1.zhimg.com/v2-0d8d325dc086b794da1ec6f6a628b563_l.jpg?source=d0bb80aa" alt="">
            </a>
          </a-col>
          <a-col :sm="6" :xl="4" :xs="30" :lg="4">
            <a href="https://motion.yoo-ai.com/?from=phpcms9.com" target="_blank">
              <img class="hover-image" src="https://picx.zhimg.com/v2-9ed15addd098bb41f12a8a80c7d101d8_l.jpg?source=d0bb80aa" alt="">
            </a>
          </a-col>
          <a-col :sm="6" :xl="4" :xs="30" :lg="4">
            <a href="https://10sppt.com/pptx/" target="_blank">
              <img class="hover-image" src="https://pic1.zhimg.com/v2-574b8fc5b846ec702b83cbd43f23f35d_l.jpg?source=d0bb80aa" alt="">
            </a>
          </a-col>
          <a-col :sm="6" :xl="4" :xs="30" :lg="4">
            <a href="https://gamma.app/" target="_blank">
              <img class="hover-image" src="https://pic1.zhimg.com/v2-a5026bd5d1b7aab021fa509109b5bea0_l.jpg?source=d0bb80aa" alt="">
            </a>
          </a-col>
          <a-col :sm="6" :xl="4" :xs="30" :lg="4">
            <a href="https://www.iflyrec.com/zhuanwenzi.html" target="_blank">
              <img class="hover-image" src="https://pic1.zhimg.com/v2-205f6ac3518e793ee3a41e054c05fb47_l.jpg?source=d0bb80aa" alt="">
            </a>
          </a-col>
        </a-row>
      </div>
    </div>
    <div>
      <div style="height: 25px;
        color: #000;
        font-family: PingFang SC;
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        letter-spacing: .36px;
        margin-left: 5%;
        margin-top:50px;">智能数据分析
      </div>
      <div class="main">
        <a-row :gutter="48">
          <a-col :sm="6" :xl="4" :xs="30" :lg="4">
            <a href="https://chatexcel.com/" target="_blank">
              <img class="hover-image" src="https://picx.zhimg.com/v2-80e7e69690e3925bc8824a85556fad0f_l.jpg?source=d0bb80aa" alt="">
            </a>
          </a-col>
          <a-col :sm="6" :xl="4" :xs="30" :lg="4">
            <a href="https://ajelix.com/?ref=www.ailookme.com" target="_blank">
              <img class="hover-image" src="https://picx.zhimg.com/v2-ec1f314a060c14ad2fb18a4231349b12_l.jpg?source=d0bb80aa" alt="">
            </a>
          </a-col>
          <a-col :sm="6" :xl="4" :xs="30" :lg="4">
            <a href="https://www.formulabot.com/?ref=www.ailookme.com" target="_blank">
              <img class="hover-image" src="https://picx.zhimg.com/v2-23795aeaadc7d373b2a5e32ae4e4ffdb_l.jpg?source=d0bb80aa" alt="">
            </a>
          </a-col>
          <a-col :sm="6" :xl="4" :xs="30" :lg="4">
            <a href="https://www.formulabot.com/?ref=www.ailookme.com" target="_blank">
              <img class="hover-image" src="	https://pic1.zhimg.com/v2-5d8ba2a391c332844014211006c3413a_l.jpg?source=d0bb80aa" alt="">
            </a>
          </a-col>
          <a-col :sm="6" :xl="4" :xs="30" :lg="4">
            <a href="https://www.formulabot.com/?ref=www.ailookme.com" target="_blank">
              <img class="hover-image" src="https://picx.zhimg.com/v2-dffa8147d12acc4e324247e3d7feb66e_l.jpg?source=d0bb80aa" alt="">
            </a>
          </a-col>
          <a-col :sm="6" :xl="4" :xs="30" :lg="4">
            <a href="https://www.chatmind.tech/" target="_blank">
              <img class="hover-image" src="https://pic1.zhimg.com/v2-ee4edb5a6d42b90e1e6409e41239f1a7_l.jpg?source=d0bb80aa" alt="">
            </a>
          </a-col>
          <a-col :sm="6" :xl="4" :xs="30" :lg="4">
            <a href="https://shutu.cn/" target="_blank">
              <img class="hover-image" src="https://picx.zhimg.com/v2-bd6ae669954f01d220084e8a84a364cf_l.jpg?source=d0bb80aa" alt="">
            </a>
          </a-col>
          <a-col :sm="6" :xl="4" :xs="30" :lg="4">
            <a href="https://shutu.cn/" target="_blank">
              <img class="hover-image" src="https://pic1.zhimg.com/v2-b5af116171d392a6e938a236f7ac03d6_l.jpg?source=d0bb80aa" alt="">
            </a>
          </a-col>
          <a-col :sm="6" :xl="4" :xs="30" :lg="4">
            <a href="https://markmap.js.org/" target="_blank">
              <img class="hover-image" src="https://pic1.zhimg.com/v2-de9a76918b07586158ff013efd343177_l.jpg?source=d0bb80aa" alt="">
            </a>
          </a-col>
          <a-col :sm="6" :xl="4" :xs="30" :lg="4">
            <a href="https://amymind.com/" target="_blank">
              <img class="hover-image" src="https://pica.zhimg.com/v2-57ba558ae292cf3b4285bd67ba17b330_l.jpg?source=d0bb80aa" alt="">
            </a>
          </a-col>
        </a-row>
      </div>
    </div>
    <div>
      <div style="height: 25px;
        color: #000;
        font-family: PingFang SC;
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        letter-spacing: .36px;
        margin-left: 5%;
        margin-top:50px;">智能图像生成
      </div>
      <div class="main">
        <a-row :gutter="48">
          <!-- <a-col :sm="6" :xl="4" :xs="10" :lg="4">
            <a href="https://chatexcel.com/" target="_blank">
              <img class="hover-image" src="https://picx.zhimg.com/v2-cf011d0138b5392179957b827e8d4175_l.jpg?source=d0bb80aa" alt="">
            </a>
          </a-col> -->
          <a-col :sm="6" :xl="4" :xs="10" :lg="4">
            <a href="https://www.tiamat.com/" target="_blank">
              <img class="hover-image" src="https://picx.zhimg.com/v2-39afc3a05e683040a3d918af3fe5bd68_l.jpg?source=d0bb80aa" alt="">
            </a>
          </a-col>
          <a-col :sm="6" :xl="4" :xs="10" :lg="4">
            <a href="https://www.wujieai.com/ai" target="_blank">
              <img class="hover-image" src="https://pica.zhimg.com/v2-aba679bf09f454ffe7ee5e706226cb47_l.jpg?source=d0bb80aa" alt="">
            </a>
          </a-col>
          <a-col :sm="6" :xl="4" :xs="10" :lg="4">
            <a href="https://tongyi.aliyun.com/wanxiang/?utm_source=ai-bot.cn" target="_blank">
              <img class="hover-image" src="https://pica.zhimg.com/v2-9f88faa3cf15eb0e88b88262f16c299d_l.jpg?source=d0bb80aa" alt="">
            </a>
          </a-col>
          <a-col :sm="6" :xl="4" :xs="10" :lg="4">
            <a href="https://yige.baidu.com/" target="_blank">
              <img class="hover-image" src="https://picx.zhimg.com/v2-14956ad3cdabcaa4389adff0ced5ff85_l.jpg?source=d0bb80aa" alt="">
            </a>
          </a-col>
        </a-row>
      </div>
    </div>
    <div>
      <div style="height: 25px;
        color: #000;
        font-family: PingFang SC;
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        letter-spacing: .36px;
        margin-left: 5%;
        margin-top:50px;">智能音视频处理
      </div>
      <div class="main">
        <a-row :gutter="48">
          <a-col :sm="6" :xl="4" :xs="10" :lg="4">
            <a href="https://runwayml.com/" target="_blank">
              <img class="hover-image" src="https://picx.zhimg.com/v2-05bf287ecbed4cd8fe7549f21f89b601_l.jpg?source=d0bb80aa" alt="">
            </a>
          </a-col>
          <a-col :sm="6" :xl="4" :xs="10" :lg="4">
            <a href="https://www.capcut.cn/" target="_blank">
              <img class="hover-image" src="https://pica.zhimg.com/v2-2afaa9c527b02c096a9953dead2303eb_l.jpg?source=d0bb80aa" alt="">
            </a>
          </a-col>
          <a-col :sm="6" :xl="4" :xs="10" :lg="4">
            <a href="https://peiyinshenqi.com/#/" target="_blank">
              <img class="hover-image" src="https://picx.zhimg.com/v2-0e02165eb3839b9d3ce47ebe951ea969_l.jpg?source=d0bb80aa" alt="">
            </a>
          </a-col>
          <a-col :sm="6" :xl="4" :xs="10" :lg="4">
            <a href="http://v.ncdsnc.com/v1/voice" target="_blank">
              <img class="hover-image" src="https://pic1.zhimg.com/v2-0697bab465a8704454f63216829d0522_l.jpg?source=d0bb80aa" alt="">
            </a>
          </a-col>
          <a-col :sm="6" :xl="4" :xs="10" :lg="4">
            <a href="https://zenvideo.qq.com/" target="_blank">
              <img class="hover-image" src="https://pica.zhimg.com/v2-a06ec699a94132e49dd755dac47d8fc2_l.jpg?source=d0bb80aa" alt="">
            </a>
          </a-col>
          <a-col :sm="6" :xl="4" :xs="10" :lg="4">
            <a href="https://www.rask.ai/" target="_blank">
              <img class="hover-image" src="https://pica.zhimg.com/v2-a6770e4688cf111938b98bc8f7ae9add_l.jpg?source=d0bb80aa" alt="">
            </a>
          </a-col>
          <a-col :sm="6" :xl="4" :xs="10" :lg="4">
            <a href="https://elevenlabs.io/dubbing" target="_blank">
              <img class="hover-image" src="https://pic1.zhimg.com/v2-9e12e6c5e91fa02c1b736c3bdc233fa3_l.jpg?source=d0bb80aa" alt="">
            </a>
          </a-col>
          <a-col :sm="6" :xl="4" :xs="10" :lg="4">
            <a href="https://studio.d-id.com/" target="_blank">
              <img class="hover-image" src="https://pic1.zhimg.com/v2-dfa3bbe35ad228e983cbff65bde7a29e_l.jpg?source=d0bb80aa" alt="">
            </a>
          </a-col>
          <a-col :sm="6" :xl="4" :xs="10" :lg="4">
            <a href="https://virbo.wondershare.cn/" target="_blank">
              <img class="hover-image" src="https://pic1.zhimg.com/v2-e74c7d78c1435abb7670dd00d652c0ce_l.jpg?source=d0bb80aa" alt="">
            </a>
          </a-col>
        </a-row>
      </div>
    </div>
    <div>
      <div style="height: 25px;
        color: #000;
        font-family: PingFang SC;
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        letter-spacing: .36px;
        margin-left: 5%;
        margin-top:50px;">扩展AI工具
      </div>
      <div class="main">
        <a-row :gutter="48">
          <a-col :sm="6" :xl="4" :xs="10" :lg="4">
            <a href="https://chatglm.cn/?lang=zh" target="_blank">
              <img class="hover-image" src="https://pica.zhimg.com/v2-744b0e1ec9125559db8eb9b2d53a5a64_l.jpg?source=d0bb80aa" alt="">
            </a>
          </a-col>
          <a-col :sm="6" :xl="4" :xs="10" :lg="4">
            <a href="https://www.tiangong.cn/" target="_blank">
              <img class="hover-image" src="https://picx.zhimg.com/v2-2305bc4444d000d17880b2cafe9b00d3_l.jpg?source=d0bb80aa" alt="">
            </a>
          </a-col>
          <a-col :sm="6" :xl="4" :xs="10" :lg="4">
            <a href="https://kimi.moonshot.cn/" target="_blank">
              <img class="hover-image" src="https://pic1.zhimg.com/v2-2ca63e094877f9c228545fd9227dbefd_l.jpg?source=d0bb80aa" alt="">
            </a>
          </a-col>
          <a-col :sm="6" :xl="4" :xs="10" :lg="4">
            <a href="https://www.doubao.com/chat/" target="_blank">
              <img class="hover-image" src="https://pic1.zhimg.com/v2-e1fccd713bfc42c8c8b3a73b96804afe_l.jpg?source=d0bb80aa" alt="">
            </a>
          </a-col>
          <a-col :sm="6" :xl="4" :xs="10" :lg="4">
            <a href="https://www.deepl.com/zh/translator" target="_blank">
              <img class="hover-image" src="https://pic1.zhimg.com/v2-75e2fe31e293b765cb77e45888bfdacd_l.jpg?source=d0bb80aa" alt="">
            </a>
          </a-col>
          <a-col :sm="6" :xl="4" :xs="10" :lg="4">
            <a href="https://chatdoc.xfyun.cn/new-chat" target="_blank">
              <img class="hover-image" src="https://pic1.zhimg.com/v2-a5c77e5aead404a07c80113c00b277cf_l.jpg?source=d0bb80aa" alt="">
            </a>
          </a-col>
        </a-row>
      </div>
    </div>
  </div>
</template>

<style scoped>
.back {
  background-image: url('@/assets/back.svg');
}
.main {
  margin-top: 20px;
  display: flex;
  flex-direction: row;
  justify-content: left;
  align-items: left;
  flex-wrap: wrap;
  margin: 0 -20px 0 5%;
}

.hover-image {
  width: 210px;
  height: 80px;
  transition: transform 0.3s ease;
}

.hover-image:hover {
  transform: scale(1.1);
}
</style>
